import request from '@/utils/request';

/**
 * 获取系统邮箱配置
 */
export function getMailConfig() {
  return request({
    url: '/manager/sysConfig/mail-detail',
    method: 'get'
  });
}

/**
 * 保存系统邮箱配置
 * @param {Object} data - 邮箱配置
 * @param {string} data.protocol - 协议(smtp/smtps)
 * @param {string} data.host - SMTP服务器地址
 * @param {number} data.port - SMTP端口
 * @param {string} data.userName - 发件人邮箱/用户名
 * @param {string} data.password - 邮箱密码
 */
export function saveMailConfig(data) {
  return request({
    url: '/manager/sysConfig/mail-save',
    method: 'post',
    data
  });
}

/**
 * 测试邮箱连接
 * @param {Object} data - 邮箱配置
 * @param {string} data.protocol - 协议(smtp/smtps)
 * @param {string} data.host - SMTP服务器地址
 * @param {number} data.port - SMTP端口
 * @param {string} data.userName - 发件人邮箱/用户名
 * @param {string} data.password - 邮箱密码
 */
export function testMailConnect(data) {
  return request({
    url: '/manager/sysConfig/mail-connect',
    method: 'post',
    data
  });
}
